<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    

    
    <g id="Home-2021" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Desktop---1440x1024" transform="translate(-876.000000, -4050.000000)" fill="#F5A623" fill-rule="nonzero">
            <g id="bloc-app" transform="translate(-124.000000, 3862.000000)">
                <g id="Group-14" transform="translate(1000.000000, 124.000000)">
                    <g id="Group-10" transform="translate(0.000000, 64.000000)">
                        <polygon id="Star" points="13.5 21 5.56489909 25.3262379 7.08036852 16.163119 0.66073703 9.67376208 9.53244955 8.33688104 13.5 0 17.4675505 8.33688104 26.339263 9.67376208 19.9196315 16.163119 21.4351009 25.3262379"></polygon>
                    </g>
                </g>
            </g>
        </g>
    </g>

  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Star',
    },
    name: {
      type: String,
      required: false,
      default: 'PtcyRatingStarFull',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 27 26',
    },
  },
};
</script>

<style scoped>
  
</style>